<template>
  <div ref="dropdownRef" class="filter-option relative w-full">
    <ul
      v-if="isOpen"
      class="options absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 max-h-[14.3rem] overflow-y-auto"
    >
      <li
        v-for="option in options"
        :key="option"
        class="option text-gray-900 font-normal flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-100"
        :class="{ 'bg-ash-300': selectedValues.includes(option) }"
        @click.stop="onOptionClick(option)"
      >
        <span class="option-label">{{ option }}</span>

        <!-- Checkmark when selected -->
        <Icon
          v-if="selectedValues.includes(option)"
          icon="check"
          class="text-gray-900"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import Icon from '../../atom/icon.vue'

const props = defineProps<{
  options: string[]
  selectedValues: string[]
  filterKey: string
  isOpen: boolean
  isSortBy: boolean
}>()

const emit = defineEmits<{
  (e: 'select', payload: { key: string; value: string }): void
  (e: 'close'): void
}>()

const dropdownRef = ref<HTMLElement | null>(null)

const onOptionClick = (option: string) => {
  emit('select', { key: props.filterKey, value: option })

  if (props.isSortBy) {
    emit('close')
  }
}

const handleClickOutside = (e: MouseEvent) => {
  if (!props.isOpen) return

  if (dropdownRef.value && !dropdownRef.value.contains(e.target as Node)) {
    emit('close')
  }
}

onMounted(() => document.addEventListener('click', handleClickOutside))
onBeforeUnmount(() =>
  document.removeEventListener('click', handleClickOutside)
)
</script>
